module.exports = __webpack_public_path__ + "img/hxzb-img9.a490035e.png";